export const APP_LOADING = 'APP_LOADING'

export const appLoadingStatus = loading => ({
  type: APP_LOADING,
  loading
})
